import * as Utils from './../_ws/utils';
import * as Config from './../_ws/config';
import * as WsCommandEnum from './../_ws/WsCommandEnum';
import {DESCRIPTION_ERROR_NOTE} from "./../_ws/WsCommandEnum";

const customWebSocketAction = function (sendData, command) {
    if (!Utils.isWebsocketReady()) {
        return;
    }
    window.spinner.show();
    switch (command) {
        case WsCommandEnum.CONFIGURATOR_SIMPLY_URL:
        case WsCommandEnum.CONFIGURATOR:
        case WsCommandEnum.CONFIGURATOR_OPTIONAL:
        case WsCommandEnum.NEWSNEES:
        case WsCommandEnum.BESTSELLER:
        case WsCommandEnum.SEARCHER:
        case WsCommandEnum.SALE: {
            document.body.scrollTop = 0;
            // document.documentElement.scrollTop = 0;
            window.paginationObj.sale = 1;
            Utils.sendNewCommandMessage(command, {
                'cToken': Config.getProlineAppDataByKey('token'),
                'formData': sendData,
            });
            break;
        }
        case WsCommandEnum.CATEGORIES: {
            document.body.scrollTop = 0;
            // document.documentElement.scrollTop = 0;
            Utils.sendNewCommandMessage(command, {
                'cToken': Config.getProlineAppDataByKey('token'),
                'formData': sendData,
            });
            break;
        }
        case WsCommandEnum.ARTICLES: {
            document.body.scrollTop = 0;
            // document.documentElement.scrollTop = 0;
            Utils.sendNewCommandMessage(command, {
                'cToken': Config.getProlineAppDataByKey('token'),
                'formData': sendData,
            });
            break;
        }
        case WsCommandEnum.PRODUCERS:
        case WsCommandEnum.UPDATE_DELIVERY_ORDER_DATA:
        case WsCommandEnum.UPDATE_ORDER_COMMENT:
        case WsCommandEnum.UPDATE_ORDER_COMMENT:
            window.spinner.hide();
            Utils.sendNewCommandMessage(command, {
                'cToken': Config.getProlineAppDataByKey('token'),
                'formData': sendData,
            });
            break;
    }
}

const webSocketAction = function (form) {
    const formH = $(form);
    const command = formH.data('ws');
    const formData = {};
    $.each(formH.serializeArray(), function () {
        formData[this.name] = this.value;
    });
    formData['formName'] = formH.attr('name');

    const data = {
        'cToken': Config.getProlineAppDataByKey('token'),
        'formData': formData,
    };

    switch (command) {
        case WsCommandEnum.CONFIGURATOR:
            window.spinner.show();
            if (formH.find('.input-block').hasClass('d-none')) {
                data.formData.productAmount = null;
            } else {
                data.formData.productSelect = null;
            }
            data.formData.url = formH.attr('action');
            data.formData.name = formH.data('tile-name');
            data.formData.group = formH.data('tile-type');
            data.formData.query = null;
            Utils.sendNewCommandMessage(command, data);
            break;
        case WsCommandEnum.CONFIGURATOR_OPTIONAL:
            window.spinner.show();
            if (formH.find('.input-block').hasClass('d-none')) {
                data.formData.productAmount = null;
            } else {
                data.formData.productSelect = null;
            }
            data.formData.url = formH.attr('action');
            data.formData.name = formH.data('tile-name');
            data.formData.group = formH.data('tile-type');
            data.formData.query = null;
            Utils.sendNewCommandMessage(command, data);
            break;
        case WsCommandEnum.CHANGE_CATEGORY_PRODUCT_AMOUNT:
            // window.spinner.showSubmitStatus(formH, true);
            const urlParams = new URLSearchParams(window.location.search);
            data.formData.query = Object.fromEntries(urlParams.entries());
            data.formData.url = window.location.href;
            Utils.sendNewCommandMessage(command, data);
            break;
        case WsCommandEnum.BUG_REPORT:
            Utils.sendNewCommandMessage(command, data);
            break;
        case WsCommandEnum.DEFAULT_PAYMENT:
        case WsCommandEnum.DEFAULT_SHIPMENT:
        case WsCommandEnum.SET_PRIMARY_ADDRESS:
            window.spinner.show(formH);
            Utils.sendNewCommandMessage(command, data);
            break;
        case WsCommandEnum.DEFAULT_AMOUNT:
        case WsCommandEnum.DEFAULT_SORTING:
            // window.spinner.showSubmitStatus(formH.find('select'));
            Utils.sendNewCommandMessage(command, data);
            break;
        case WsCommandEnum.ADD_ADDRESS:
        case WsCommandEnum.ADD_ADDRESS_ORDER:
        case WsCommandEnum.ADD_ORDER_PARCEL_LOCKER:
        case WsCommandEnum.EDIT_ADDRESS:
            const modal = formH.closest('.modal');
            data.modalId = modal.attr('id');
        case WsCommandEnum.ADD_COMMENT_NEWS:
            data.formData.url = $(formH).data('url');
        case WsCommandEnum.ADD_COMMENT:
        case WsCommandEnum.ADD_ORDER_COMMENT:
            window.spinner.show($('.spinner-tool'));
        case WsCommandEnum.CART_ADD_PROMO:
        case WsCommandEnum.CART_CLEAN:
        case WsCommandEnum.CART_SAVE:
        case WsCommandEnum.CART_SAVE_ADD:
        case WsCommandEnum.PRIVATE_LIST_TO_CART:
        case WsCommandEnum.CART_SAVE_CHANGE_NAME:
        case WsCommandEnum.CHANGE_ACCOUNT_DATA:
        case WsCommandEnum.CHANGE_EMAIL:
        case WsCommandEnum.CHANGE_ORDER_PAYMENT: {
            $('#consentsForm input[type=checkbox]:checked').each(function (i, e) {
                data.formData[$(e).attr('name')] = $(e).val();
            });
            if ($('#consentsForm input#policyConsentsForm').length === 1) {
                data.formData['policy'] = $('#consentsForm input#policyConsentsForm').val();
            }
        }
        case WsCommandEnum.CHANGE_ORDER_SHIPMENT:
        case WsCommandEnum.CHANGE_PASSWORD:
        case WsCommandEnum.CHANGE_PROLINE_OFFICE:
        case WsCommandEnum.CONSENTS:
        case WsCommandEnum.DELETE_ADDRESS:
        case WsCommandEnum.PERSONALIZATION:
        case WsCommandEnum.REGISTER_NIP:
        case WsCommandEnum.REGISTER_STAGE2:
        case WsCommandEnum.SERVICE_ADD:
        case WsCommandEnum.SUMMARY_ORDER:
        case WsCommandEnum.SEND_QUESTION:
        case WsCommandEnum.ORDERS_FILTERING:
        case WsCommandEnum.DELIVERY_NOTIFICATION:
        case WsCommandEnum.DESCRIPTION_ERROR_NOTE:
            Utils.sendNewCommandMessage(command, data);
            break;
        case WsCommandEnum.ADD_PRIORITY:
            Utils.sendNewCommandMessage(command, data);
            break;
        case WsCommandEnum.PRODUCT_ADD:
        case WsCommandEnum.PRODUCT_ADD_SINGLE:
        case WsCommandEnum.PRODUCT_CHANGE:
        case WsCommandEnum.PRODUCT_REMOVE:
            data.formData.url = formH.attr('action') ?? window.location.href;
            let matches = data.formData.url.match(window.location.origin);
            if (matches === null) {
                data.formData.url = window.location.href;
            }

            let sliderInputs = document.querySelectorAll('input[type="range"]');
            $(sliderInputs).each(function (i, e) {
                let sliderHandle = e['rangeslider-js'];
                sliderHandle.destroy();
            });
            Utils.sendNewCommandMessage(command, data);
            break;
        case WsCommandEnum.SWITCH_CUSTOMER:
            let newForm = formH.clone();
            newForm.removeAttr('data-ws');
            Utils.sendNewCommandMessage(command, data);
            newForm.attr('id', 'fastForm');
            newForm.appendTo('body');
            $('form#fastForm').submit();
            break;
        case WsCommandEnum.CART_FROM_LIST:
            data.formData.toCart = {};
            $('input.toCart[type=checkbox]:checked').each(function (index, e) {
                if ($(e).data('badge')) {
                    data.formData.toCart[parseInt($(e).data('badge'))] = $(e).closest('div.product').find('input[name="listProductAmount"]').val() ?? 1;
                }
            });
            if (Object.keys(data.formData.guid).length > 0) {
                Utils.sendNewCommandMessage(command, data);
            }
            break;
        case WsCommandEnum.RECOMMENDED_PRODUCTS_TO_CART:
            data.formData.toCart = {};
            $('input.toCart[type=checkbox]:checked').each(function (index, e) {
                if ($(e).data('badge')) {
                    data.formData.toCart[parseInt($(e).data('badge'))] = $(e).closest('div.product').find('input[name="listProductAmount"]').val() ?? 1;
                }
            });

            if (Object.keys(data.formData.toCart).length > 0) {
                Utils.sendNewCommandMessage(command, data);
            }
            break;
        case WsCommandEnum.LIST_CHANGE_PRODUCT_AMOUNT:
        case WsCommandEnum.LIST_DELETE_PRODUCT:
        case WsCommandEnum.LIST_DELETE:
            Utils.sendNewCommandMessage(command, data);
            break;
        default:
            form.submit();
    }
}

export {
    webSocketAction,
    customWebSocketAction,
}
